<template>
  <div>
    <div class="page_title flex_between">
      <span>
        <span>养生方审核详情</span>
        <span
          style="background-color: #ffecda; color: #f48a15"
          class="status"
          v-if="detail.reviewed_status == 1"
          >待审核</span
        >
        <span
          style="background-color: #e5f1e3; color: #669961"
          class="status"
          v-if="detail.reviewed_status == 2"
          >审核通过</span
        >
        <span
          style="background-color: #ffe4e4; color: #d76b59"
          class="status"
          v-if="detail.reviewed_status == 3"
          >审核不通过</span
        >
      </span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="padding: 0 20px">
          <span class="itemtitle">提交日期：</span>
          <span>{{ detail.update_time }}</span>
        </div>
        <div
          style="width: 100%; height: 1px; background: #e8e9f0; margin: 16px 0"
        ></div>
        <div style="padding: 0 20px">
          <div class="itemtitle">药房信息</div>
          <div class="infobox">
            <div>
              <span style="display: inline-block; width: 300px">
                <span class="gray">药房名称：</span>
                <span class="black">{{ detail.hospital_name }}</span>
              </span>
              <span>
                <span class="gray">药房类型：</span>
                <span class="black">{{ detail.org_type }}</span>
              </span>
            </div>
            <div style="margin: 20px 0">
              <span style="display: inline-block; width: 300px">
                <span class="gray">纳税人识别号：</span>
                <span class="black">{{ detail.identification_number }}</span>
              </span>
              <span>
                <span class="gray">所在区域：</span>
                <span class="black">{{ detail.address }}</span>
              </span>
            </div>
          </div>
          <div class="itemtitle">养生方信息</div>
          <div>
            <div class="infobox">
              <div>
                <span style="display: inline-block; width: 300px">
                  <span class="gray">养生方编号：</span>
                  <span class="black">{{ detail.oil_code }}</span>
                </span>
                <span style="display: inline-block; width: 300px">
                  <span class="gray">养生方名称：</span>
                  <span class="black">{{ detail.oil_name }}</span>
                </span>
              </div>
              <div style="margin: 20px 0">
                <span style="display: ">
                  <span class="gray">规格：</span>
                  <span class="black">{{ detail.oil_spec }}</span>
                </span>
                <span>
                  <span class="gray">单位：</span>
                  <span class="black">{{ detail.oil_unit }}</span>
                </span>
                <span>
                  <span class="gray">重量：</span>
                  <span class="black">{{ detail.weight }}g</span>
                </span>
                <span>
                  <span class="gray">销售价：</span>
                  <span class="black">{{ detail.price }}元</span>
                </span>
              </div>
              <div style="margin: 20px 0">
                <span class="gray">医生端是否可见：</span>
                <span class="black">{{
                  detail.is_show_doctor == 1 ? "是" : "否"
                }}</span>
              </div>
              <div class="flex">
                <span class="gray">养生方主图：</span>

                <div class="gfimgbox">
                  <el-image
                    v-for="(item, index) in detail.oil_thumb_str"
                    :key="index"
                    class="imgitem"
                    :src="item"
                    :preview-src-list="[detail.oil_thumb_str]"
                  >
                  </el-image>
                </div>
              </div>

              <div>
                <span style="display: inline-block; width: 300px">
                  <span class="gray">养生方描述：</span>
                  <span class="black">{{ detail.oil_desc }}</span>
                </span>
                <span style="display: inline-block; width: 320px">
                  <span class="gray">适应症：</span>
                  <span class="black">{{ detail.oil_disease }}</span>
                </span>
              </div>

              <div style="margin: 20px 0">
                <span style="display: inline-block; width: 300px">
                  <span class="gray">配方：</span>
                  <span class="black">{{ detail.oil_recipe }}</span>
                </span>
              </div>

              <div>
                <span style="display: inline-block; width: 320px">
                  <span class="gray">用法用量：</span>
                  <span class="black">{{ detail.oil_method }}</span>
                </span>
                <span style="display: inline-block; width: 320px">
                  <span class="gray">贮藏：</span>
                  <span class="black">{{ detail.oil_storage }}</span>
                </span>
              </div>

              <div style="margin: 20px 0">
                <span style="display: inline-block; width: 300px">
                  <span class="gray">补充说明：</span>
                  <span class="black">{{ detail.oil_more_desc }}</span>
                </span>
              </div>
              

              <div class="flex" style="margin-top: 20px">
                <span class="gray">养生方详情：</span>
                <div class="gfimgbox">
                  <el-image
                    v-for="(item, index) in detail.oil_thumb_info_str"
                    :key="index"
                    class="imgitem"
                    :src="item"
                    :preview-src-list="[detail.oil_thumb_info_str]"
                  >
                  </el-image>
                </div>
              </div>
            </div>
          </div>
          <div class="itemtitle" v-if="detail.content.length">Rp</div>
          <div v-if="detail.content.length">
            <div class="infobox flex wrap" style="margin-bottom: 0px">
              <div
                v-for="item in detail.content"
                :key="item.drug_id"
                class="flex drug align-center"
              >
                <span class="s1">{{ item.generic_name }}</span>
                <span class="s2"
                  >{{ item.item_use_level }}g{{ item.requirement }}</span
                >
              </div>
            </div>
          </div>
          <div style="margin-top: 40px" v-if="detail.reviewed_status == 1">
            <el-button
              plain
              @click="examine(3)"
              style="width: 100px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('267') : false
              "
              >不通过</el-button
            >
            <el-button
              type="primary"
              @click="examine(2)"
              style="width: 100px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('267') : false
              "
              >通过</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import _ from "lodash";
export default {
  data() {
    return {
      business_license: "",
      drug_trade_license: "",
      gsp: "",
      id_card_face: "",
      id_card_side: "",
      detail: {
        content: [],
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取药品审核详情
    getReviewed() {
      let oil_id = this.$route.query.oil_id;
      this.axios
        .post("platform/ointment/getOintmentAuthInfo", { oil_id })

        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            this.detail = res.data.info;
            this.detail.update_time = platform.timestampToTime(
              this.detail.update_time
            );
            this.detail.oil_thumb_str = this.detail.oil_thumb_str.split(",");
          }
        });
    },
    //审核
    examine(status) {
      let oil_id = this.$route.query.oil_id;
      let auth_status = status;
      let text = "";
      if (status == 3) {
        text = "未通过";
      } else {
        text = "通过";
      }
      this.$confirm(`是否审核${text}？`, "审核", {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.axios
            .post("platform/ointment/auditOintment", { oil_id, auth_status })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success(`该药品审核${text}!`);
                this.back();
              }
            });
        })
        .catch();
    },
    back() {
      history.back();
    },
  },
  created() {
    this.getReviewed();
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 24px 0;
  box-sizing: border-box;
  background: #ffffff;
  min-width: 1000px;
  text-align: left;
  min-height: calc(100vh - 140px);
}

.black {
  color: #000;
}
.gray {
  color: #666;
  display: inline-block;
  text-align: right;
  width: 120px;
}
.itemtitle {
  color: #333;
  font-weight: 600;
  margin-bottom: 12px;
}
.infobox {
  height: 100%;
  border: solid 1px #cfcece;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.imglist {
  padding-right: 40px;
  display: flex;
  justify-content: space-between;
  .imgitem {
    width: 200px;
    .imgbox {
      width: 200px;
      height: 140px;
      border: solid 1px #d6d6d6;
      padding: 10px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .imgtext {
      color: #737982;
      font-weight: 600;
      margin-bottom: 8px;
    }
  }
}
.status {
  display: inline-block;
  border-radius: 2px;
  height: 20px;
  line-height: 20px;
  padding: 3px 8px;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 400;
}
.pricebox {
  border: solid 1px #cfcece;
  height: 40px;
  line-height: 40px;
  border-top: 0px solid #fff;
  padding-left: 20px;
  box-sizing: border-box;
}
.drug {
  margin-bottom: 15px;
  margin-right: 30px;
  .s1 {
    width: 70px;
  }
}
.img {
  width: 100px;
}
.gfimgbox {
  width: 1200px;
  display: flex;
  flex-wrap: wrap;
  .imgitem {
    width: 100px;
    height: 100px;
    margin: 0 10px 10px 0;
  }
}
</style>